/**
 * This module detect the page direction depends on the dir attribute of the html tag for checking the RTL direction.
 */

export default function isPageDirectionRightToLeft() {
  const dir = document.querySelector('html').getAttribute('dir');
  return dir && dir.toLowerCase() === 'rtl';
}
